import React from "react";
import classes from "./SocialTemp.module.css";
const socialTemp = (props) => {
  return (
    <div className={classes.SocialDiv}>
      <a href={props.link} target="blank">
        {props.logo}
        {/* <img src={props.logo} alt={props.link} /> */}
      </a>{" "}
    </div>
  );
};

export default socialTemp;
